export default __webpack_public_path__ + "static/media/img_baseCrochetRattle_lemon.06172cd7.jpg";